module.exports = __webpack_public_path__ + "static/media/information-green-icon.0f1da182.svg";